import React from 'react';
import { useUserData } from '../hooks/useUserData';

const KPICards = ({ user }) => {
  const userData = useUserData(user?.uid);

  if (!userData) {
    return (
      <div className="p-4 text-gray-600 text-sm">
        ⏳ Loading KPI data...
      </div>
    );
  }

  const {
    weeklySessions,
    attendanceRate,
    utilizationRate,
    avgRevenueWeek,
    avgRevenuePerSession,
    costPerWeek,
    profitPerWeek,
    conversionRate,
    timeToFirst,
    adminTime,
    churnRate,
    notesPending
  } = userData;

  const Card = ({ label, value }) => (
    <div className="bg-white rounded shadow p-4 text-center w-full sm:w-1/3">
      <div className="text-sm text-gray-500">{label}</div>
      <div className="text-2xl font-bold text-gray-800">{value}</div>
    </div>
  );

  return (
    <div className="p-4 space-y-2">
      <div className="flex flex-wrap gap-4 justify-center">
        <Card label="Sessions / Week" value={weeklySessions || '—'} />
        <Card label="Attendance Rate" value={`${attendanceRate || 0}%`} />
        <Card label="Utilization Rate" value={`${utilizationRate || 0}%`} />
        <Card label="Avg Revenue / Week" value={`$${avgRevenueWeek || 0}`} />
        <Card label="Revenue / Session" value={`$${avgRevenuePerSession || 0}`} />
        <Card label="Cost / Week" value={`$${costPerWeek || 0}`} />
        <Card label="Profit / Week" value={`$${profitPerWeek || 0}`} />
        <Card label="Conversion Rate" value={conversionRate || '—'} />
        <Card label="Time to First Appt" value={timeToFirst || '—'} />
        <Card label="Admin Time / Intake" value={adminTime || '—'} />
        <Card label="Churn Rate" value={`${churnRate || 0}%`} />
        <Card label="Notes Pending" value={notesPending || 0} />
      </div>
    </div>
  );
};

export default KPICards;
